import { useState } from 'react';
import {  IconButton, Tooltip, useTheme } from '@mui/material';
import { ArrowMinimize, ArrowMaximize, Copy } from '@jda/lui-common-icon-library-mui5';
import CopyToClipboard from 'react-copy-to-clipboard';
import JsonViewer from 'react-json-view';
import { IPolicyRuleDialogProps } from '../../models/Policies/PolicyContract';
import { COPY_RULE_MSG } from './constants';
import { useStyles } from './styles';
import { FUNCTIONAL, VIEW_POLICY } from '../../shared/PolicyDialog/constants';
import { LuiModal } from '@jda/lui-common-component-library-mui5';
import { ToolbarZone } from '@jda/lui-common-component-library-mui5/dist/src/components/LuiToolbar/types';

const PolicyRuleDialog = ({ open, rowData, displaySnackbar, handleClose }: IPolicyRuleDialogProps) => {
  const theme = useTheme();
  const { classes } = useStyles();

  const [isChecked, seIsChecked] = useState(false);
  const onCopyHandler = () => displaySnackbar(COPY_RULE_MSG, 'success');
  const handleChange = () => seIsChecked(prev => !prev);

  let policyJSONData = rowData.policyExpression || rowData;
  if (rowData.policyType === FUNCTIONAL) {
    policyJSONData = {
      name: rowData.name || '',
      moduleId: rowData.moduleId || '',
      description: rowData.description || '',
      displayName: rowData.displayName || '',
      PolicyType: FUNCTIONAL
    };
  }
  const rightZoneProps: ToolbarZone = {
      component: (<>
        <Tooltip arrow title={`${isChecked ? 'Minimize' : 'Maximize'}`} placement="top">
            <IconButton onClick={handleChange} size='small'>
              {isChecked ? <ArrowMinimize /> : <ArrowMaximize />}
            </IconButton>
          </Tooltip>
        <Tooltip arrow title="Copy" placement="top">
            <div>
              <CopyToClipboard text={JSON.stringify(rowData.policyExpression || rowData)} onCopy={onCopyHandler}>
                <IconButton size='small'>
                  <Copy />
                </IconButton>
              </CopyToClipboard>
            </div>
        </Tooltip>
        </>
      ),
      flexGrow: 1,
};
  return (
    <LuiModal
      handleClose={handleClose}
      aria-labelledby="simple-dialog-title"
      isOpen={open}
      className={`${isChecked ? `${classes.fullscreen}` : null}`}
      modalSize='md'
      modalTitle={VIEW_POLICY}
      headerZones={{
        rightZone: rightZoneProps
      }}
    >
        <JsonViewer
          name={false}
          indentWidth={5}
          src={policyJSONData}
          quotesOnKeys={false}
          enableClipboard={false}
          displayDataTypes={false}
          displayObjectSize={false}
          theme={theme.palette.mode === 'light' ? 'rjv-default' : 'harmonic'}
        />
    </LuiModal>
  );
};

export default PolicyRuleDialog;
